import Header from '../../components/admin/header/Header'

import Detail from '../../components/admin/contact/Detail';

export default function ContactDetail() {
  return (
    <>
      <Header></Header>
      <Detail />
    </>
  );
}
